export default __webpack_public_path__ + "static/media/page3.1d560368.pdf";